import Image from 'next/image'
import { useRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import { setFilters } from '@/store/slices/speakersSlice'
import { getCategoriesList } from '@/store/slices/categorySlice'

const PopularTopics = ({ data }) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const allCategories = useSelector(getCategoriesList)
  const onCategoryClick = (topic) => {
    let result = ''
    allCategories?.filter((category) =>
      category?.subCategories?.filter((subCategory) => {
        subCategory?.slug == topic?.slug ? (result = subCategory?.id) : ''
      })
    )
    dispatch(
      setFilters({
        profileCategory: null,
        categories: [result],
        searchQuery: '',
        types: null,
        relatedSpeakers: null,
        sortOrder: null,
      })
    ),
      router.push({
        pathname: `/speakers/topics/${topic?.slug}`,
      })
  }

  return (
    <div className="mb-16 lg:mb-32 md:mb-24">
      <h1 className="popular-heading">Popular Topics</h1>
      <div className="grid gap-5 xs:grid-cols-2">
        {data?.map((item, i) => (
          <div
            className="relative mb-2 cursor-pointer group"
            key={i}
            onClick={() => {
              onCategoryClick(item)
            }}
          >
            <div className="p-[32%] maxXs:h-[260px] maxXs:w-[360px]">
              {item?.image?.fields?.file?.url !== undefined ? (
                <Image
                  src={
                    'https:' +
                    item?.image?.fields?.file?.url +
                    '?fm=webp&w=610&h=395&q=100&fit=thumb&f=faces'
                  }
                  alt=""
                  layout="fill"
                  objectFit="cover"
                  objectPosition="top"
                  quality={100}
                />
              ) : (
                <Image
                  src={
                    'https://images.ctfassets.net/p6iqoqavudao/3lLPw0ct3NWRdllJaozgZr/238aa02d0b3a99038d1969146d7916f1/placeholder.png?fm=webp&w=610&h=395&q=100&fit=thumb&f=faces'
                  }
                  alt=""
                  layout="fill"
                  quality={100}
                />
              )}
            </div>

            <a className="cursor-pointer flex items-center popular-title-strip">
              <h3 className="text-sm leading-6 text-base lg:text-lg popular-topics-font group-hover:underline group-hover:underline-offset-2">
                {item.name}
              </h3>
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PopularTopics
